import {Component, NgZone} from '@angular/core';
import {Events, IonicPage, NavController, NavParams} from 'ionic-angular';
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ApiProvider} from "../../providers/api/api";

/**
 * Generated class for the AppSettingsTrainingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-settings-training',
  templateUrl: 'app-settings-training.html',
})
export class AppSettingsTrainingPage {

  trainingNotification: boolean;
  trainingDays: Map<number, boolean>;
  constructor(public navCtrl: NavController, public navParams: NavParams, public userState: UserStateProvider, public api:ApiProvider, public ngZone: NgZone, private events: Events) {
    this.trainingDays = new Map<number, boolean>();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppSettingsTrainingPage');
    var value = this.userState.user.program.trainingDays;

    for(let l=0;l<=6;l++) {
      console.log(Math.pow(2, l) , value, Math.pow(2, l) & value)
      if((Math.pow(2, l) & value) > 0) {
        this.trainingDays.set(l, true);
      }
    }

    this.trainingNotification = this.userState.user.program.trainingNotification;
  }


  enableDay(day: number) {
    this.ngZone.run(() => {
      let value = this.trainingDays.get(day);
      if(value) {
        this.trainingDays.set(day, false);
      } else {
        this.trainingDays.set(day, true);
      }
    });
  }

  saveData() {
    var data = this.userState.user.program;
    let value = 0;

    for(let l=0;l<=6;l++) {
      if(this.trainingDays.get(l)) {
        value += Math.pow(2, l);
      }
    }

    data.trainingDays = value;
    data.trainingNotification = this.trainingNotification;
    this.api.callPut('/users/'+this.userState.user.id, {program: data}).subscribe((res:any) => {

      if (this.trainingNotification) {
        this.events.publish('training:notificationEnabled')
      }

      this.userState.user.program.trainingDays = value;
      this.userState.user.program.trainingNotification = this.trainingNotification;
      this.navCtrl.pop();
    })
  }


}



// WEBPACK FOOTER //
// ./src/pages/app-settings-training/app-settings-training.ts